<div class="reset-password__content">
  <h3>{{data.title | async}}</h3>
  <div>
    {{data.message | async}}
    <em>{{data.email}}</em>
  </div>
  <p>{{'or to the following email address:' | translate}}</p>
  <mat-form-field>
    <label>
      <input [(ngModel)]="alternativeEmail"
        matInput
        #email="ngModel"
        [placeholder]="'Email' | translate"
        pattern='^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$'
        type="email">
    </label>
    @if (email.errors?.pattern) {
      <mat-error>
        {{'Please provide a valid email address.' | translate}}
      </mat-error>
    }
  </mat-form-field><br>
</div>
<div class="reset-password__actions"
  align="end">
  <button [mat-dialog-close]="false"
    id="cancel-button"
    mat-flat-button>
    {{'Cancel' | translate}}
  </button>
  <button (click)="save()" [disabled]="email.errors?.pattern"
    id="reset-button"
    color="warn"
    mat-flat-button>
    {{'Reset' | translate}}
  </button>
</div>
